import { observable, computed } from 'mobx';
import { EventStore } from './events';
import { OrderStore } from './order';
import { diInject } from 'stores/diContext';
import { EventService } from '../services/events';

/**
 * 捐赠列表项Store
 */
export class DonationItemStore {

    @diInject() eventStore: EventStore;

    @diInject() orderStore:OrderStore;

    id;
    
    @observable total_amount = 0;

    @observable amount = 0;

    constructor(public donation:IEventResultDonation) {
        this.id = donation.id;     
    }

    is_visible = this.donation.is_active;

    setData(data) {
        this.total_amount = data.amount - data.amount_refund;
    }

    is_prefilled = false;
    prefill() {
        if (!this.is_prefilled) {
            this.is_prefilled = true;
            this.setAmount(this.donation.prefilled_amount);
        }
    }

    setAmount = (val) => {
        this.amount = val;
        this.eventStore.cartStore.donation(this.id, val);        
    }
}

export class DonationsStore {
    @diInject() eventService: EventService;
    @diInject() eventStore: EventStore;

    donations: Array<DonationItemStore> = [];
   
    /**
     * 加载donation信息
     */
    async loadDonationInfo() {
        const { event } = this.eventStore;
        var donations = null;        
        var active_donations = event.donations.filter(donation => {           
            return event.is_set_donations&& donation.is_active
        });
        if (active_donations.length > 0) {
            donations = await this.eventService.getDonations(event.id, event.schedules[0].id) as Array<any>;
        }
        const stores = [];
        for (let donation of active_donations) {
            var store = new DonationItemStore(donation);
            var temp = donations.find(d => d.donation_id == donation.id);
            if (temp) {
                store.setData(temp);
            }
            stores.push(store);
        }

        this.donations = stores;
        return this.donations;
    }

}


// WEBPACK FOOTER //
// ./src/Apps/ticketing/stores/donation.ts